import React, {useState} from "react";
import { Key } from "react";
import { PriceListSearchHistoryProps } from "../types";
import { PriceListOutput } from "../";
import { FormattedMessage } from "react-intl";


export const PriceListSearchHistory = ({
  priceListHistory,
  setPriceListData,
  setStartSearch,
  fetchHistory,
}: PriceListSearchHistoryProps) => {

  return (
    <div className="flex flex-col gap-4 mb-8">
      <div className="text-lg font-semibold border-b-2 py-1">
        <FormattedMessage
          id="price_list_history"
          defaultMessage="Ultime ricerche"
        />
      </div>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {priceListHistory?.length > 0 ? (
          priceListHistory.map((pl: any, i: Key) => {
            // get data
            const { cache_key, result, id } = pl;
            const { form } = cache_key;
            // return component
            return (
              <PriceListOutput
                key={i}
                form={form}
                id={id}
                result={result}
                setPriceListData={setPriceListData}
                setStartSearch={setStartSearch}
                fetchHistory={fetchHistory}
              />
            );
          })
        ) : (
          <div className="text-lg">
            <FormattedMessage
              id="price_list_no_history"
              defaultMessage="Nessuna ricerca effettuata" />
          </div>
        )}
      </div>
    </div>
  );
};
